module.exports = __webpack_public_path__ + "static/export-catalyst-logo-b6daac5ecb0c1ca91c1e8e1cfcede383.svg";